import { z } from "zod";

export const BulkDownloadOrdersRequestBodySchema = z.object({
  startDatetime: z.string().nullish(),
  endDatetime: z.string().nullish(),
});

export type BulkDownloadOrdersRequestBodyType = z.infer<
  typeof BulkDownloadOrdersRequestBodySchema
>;
